import { Navigate, useLocation } from 'react-router'
import type { ReactNode } from 'react'
import { useAuth } from '@waago/api'
import SplashPage from './pages/SplashPage'

/**
 * Route guard. Convenience only — the server enforces on every endpoint.
 *
 * The splash frame doubles as the loading state: restoring a session from the
 * refresh cookie is exactly the moment the design fills with brand, so there is
 * no separate spinner screen to build or to flash past.
 */
export function RequireAuth({ children }: { children: ReactNode }) {
  const { state } = useAuth()
  const location = useLocation()

  if (state.status === 'loading') return <SplashPage />
  if (state.status === 'anonymous') {
    return <Navigate to="/bienvenue" replace state={{ from: location.pathname }} />
  }
  return <>{children}</>
}
